import { render } from "./hr-module-header.vue?vue&type=template&id=253e0c19&scoped=true"
import script from "./hr-module-header.vue?vue&type=script&lang=js"
export * from "./hr-module-header.vue?vue&type=script&lang=js"

import "./hr-module-header.vue?vue&type=style&index=0&id=253e0c19&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253e0c19"]])

export default __exports__